// Used on legacy pages (Enterprise, About Us, etc)
// JS Base
import '../js/base/legacy';
import '../js/index';

// Base SCSS
import '../scss/base.scss';
import '../scss/components/card.scss';

import '../scss/basepage.scss';
import '../scss/components/nodes.scss';
import '../scss/about.scss';

import { Chart, registerables } from 'chart.js';
import { CountUp } from 'countup.js';

Chart.register(...registerables);

const aboutUsChartSetup = () => {
  const ctx = document.getElementById('myChart');
  const chart = new Chart(ctx, {
    type: 'bar',
    data: {
      labels: ['Other', 'Investments', 'Insurance'],
      datasets: [{
        data: [60, 77, 92],
        borderWidth: 1,
        backgroundColor: '#FFFFFF',
      },
      { // Second part of the stack (dark grey)
        data: [40, 23, 8],
        borderWidth: 1,
        backgroundColor: '#333333',
      }
    ]
    },
    options: {
      maintainAspectRatio: false,
      scales: {
        x: {
          stacked: true,
          beginAtZero: true,
          grid: {
            display: false, // Hide the grid lines
          },
          ticks: {
            display: true,  // Show the labels,
            color: '#FFFFFF',
            font: {
              size: 16, // Change font size (e.g., 16px)
            },
          },
        },
        y: {
          beginAtZero: true,
          display: false,
          stacked: true,
        }
      },
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: false, // Disable tooltips
        }
      }
    }
  });
};

const countUpSetup = () => {
  const options = {
    enableScrollSpy: true,
  };

  $('#about-us-counter h3').each((i, v) => {
    const countTo = $(v).data('count-target');
    const countUp = new CountUp(v, countTo, options);
  });
};

$(() => {
  aboutUsChartSetup();
  countUpSetup();
});
